import Api from "../index";
import { endPoints, requestType } from "../../constants/variables";

export const getAllUsers = () => {
  return Api(`${endPoints.getAllUsers}`, null, requestType.GET);
};

export const updateUserStatus = (params) => {
    return Api(`${endPoints.updateUserStatus}`, params, requestType.PUT);
  };